module.exports = __webpack_public_path__ + "img/car_4.91e80f14.png";